<mat-form-field [appearance]="appearance" class="w-full">
    <mat-label>{{label}}</mat-label>
    <input matInput [formControl]="control">
</mat-form-field>
 

